import React from 'react'
import { List } from '@mui/material'
import OrderItem from '../Order/OrderItem';

const CardMeals = (props) => {

  const { orderItems, deleteMeal, updateQuantity } = props;

  return (
    <List >
      {
        orderItems.map((item, index) => (
          <OrderItem deleteMeal={deleteMeal} updateQuantity={updateQuantity} key={index} item={item} />
        ))
      }
    </List>
  )
}

export default CardMeals